import { IComponentOptions } from "angular";
import { GamingContractMasterDetailController } from "./controller";

export const vsName = "gamingContractMasterDetailComponent";

export const gamingContractMasterDetailComponentOptions: IComponentOptions = {
  controller: GamingContractMasterDetailController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
